import React, { useEffect, useState } from 'react';
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';

import Checkout from '../pages/checkout';
import Error from '../pages/Error';
import Layout from '../components/Layout';
import PortalLogin from '../pages/portalLogin';
import ForgotPassword from '../pages/forgot-password';
import PortalMfa from '../pages/portalMfa';
import SetPassword from '../pages/setPassword';
import NewConfirmPassword from '../pages/new-reset-password';
import AllOrders from '../pages/allOrders';
import Documents from '../pages/documents';
import Reports from '../pages/reports';
import Reports2 from '../pages/reports2';
import PrivateRoute from './privateRoute';
import OpenRoute from './openRouter';
import hematogenix from '../assets/images/Hematogenix.svg';
import { refreshTokenAction } from '../Actions/auth';
import { getAvailabeKitsAction, checkSiteForKitsAccessAction, checkSiteForReportsAccessAction } from '../Actions/orders';
import InventoryManagement from '../pages/inventoryManagement';
import AddressBook from '../pages/address';
import Collection from '../pages/collection';
import { getUserDetailsAction } from '../Actions/user';
import { setActiveSponsor, setActiveStudy, setActiveSite, setFilterStudy, setFilterSite } from '../Store/reducers/users';
import { setAllKitsforSite, setStoreItems } from '../Store/reducers/orders';

const App = () => {
  const dispatch = useDispatch();
  const [ready, setReady] = useState(false);
  const [showDashboard, setShowDashboard] = useState(true);
  const { activeSponser, userStatus, activeStudy } = useSelector((state) => state.user);
  const { orders } = useSelector((state) => state);
  useEffect(() => {
    (async () => {
      if (localStorage.getItem('hema-token')) {
        const refreshToken = await refreshTokenAction();
        setReady(true);
        if (refreshToken.status === 200) {
          localStorage.setItem('hema-token', refreshToken.data.token.accessToken);
          localStorage.setItem('hema-token-refresh', refreshToken.data.token.refreshToken);
          const result = await getUserDetailsAction();
          if (result.status === 200) {
            console.log(result);

            dispatch(setActiveSponsor(result.data.sponsors?.filter((sponser) => sponser.name === localStorage.getItem('portal-active-sponsor'))?.[0]));
            dispatch(setActiveStudy(result.data.studies?.filter((study) => study.name === localStorage.getItem('portal-active-study'))?.[0]));
            dispatch(setActiveSite(result.data.sites?.filter((site) => site.name === localStorage.getItem('portal-active-site'))?.[0]));
            await checkSiteForKitsAccessAction(result.data.sites?.filter((site) => site.name === localStorage.getItem('portal-active-site'))?.[0]?.id);
            await checkSiteForReportsAccessAction(result.data.sites?.filter((site) => site.name === localStorage.getItem('portal-active-site'))?.[0]?.id);
          }
          const updaterCartonRefresh = await getAvailabeKitsAction(localStorage.getItem('portal-active-site-id'));
          const kits = updaterCartonRefresh.data.map((data) => {
            const localItems = localStorage.getItem('cart-item-ids')?.split(',');
            if (localItems?.includes(String(data.id))) {
              const itemsAdded = localItems?.filter((itm) => itm === String(data.id))?.length;
              return { ...data, addtocart: true, count: data.count ? data.count : itemsAdded || 1 };
            } else {
              return data;
            }
          });
          dispatch(setAllKitsforSite(kits));
          dispatch(setStoreItems(kits));
        } else {
          localStorage.removeItem('hema-token');
          localStorage.removeItem('hema-token-refresh');
          window.location.reload();
        }
      } else {
        setReady(true);
      }
    })();
  }, []);
  useEffect(() => {
    if (activeSponser) {
      dispatch(setFilterStudy(userStatus?.studies?.filter((study) => study.parentId === activeSponser?.id)));
    }
    if (activeStudy) {
      dispatch(setFilterSite(userStatus?.sites?.filter((site) => site.parentId === activeStudy?.id)));
    }
  }, [activeSponser]);

  return !ready ? (
    <div className="flex items-center justify-center h-screen bg-primary2">
      <img src={hematogenix} alt="logo" />
    </div>
  ) : (
    <BrowserRouter>
      <Routes>
        <Route
          path="/login"
          element={
            <OpenRoute>
              <PortalLogin />
            </OpenRoute>
          }
        />
        <Route
          path="/mfa"
          element={
            <OpenRoute>
              <PortalMfa />
            </OpenRoute>
          }
        />
        <Route
          path="/forgot-password"
          element={
            <OpenRoute>
              <ForgotPassword />
            </OpenRoute>
          }
        />
        <Route
          path="/set-password"
          element={
            <OpenRoute>
              <SetPassword />
            </OpenRoute>
          }
        />
        <Route
          path="/reset-new-password"
          element={
            <OpenRoute>
              <NewConfirmPassword />
            </OpenRoute>
          }
        />
        <Route path="/" element={<Layout setShowDashboard={setShowDashboard} />}>
          <Route
            path="/"
            element={
              <PrivateRoute>
                {orders.kitsAccess === true ? <InventoryManagement /> : <Navigate to="/reports" replace />}
              </PrivateRoute>
            }
          />
          <Route
            path="collection"
            element={
              <PrivateRoute>
                <Collection />
              </PrivateRoute>
            }
          />
          <Route
            path="checkout"
            element={
              <PrivateRoute>
                <Checkout />
              </PrivateRoute>
            }
          />
          <Route
            path="address-book"
            element={
              <PrivateRoute>
                <AddressBook />
              </PrivateRoute>
            }
          />
          <Route
            path="orders"
            element={
              <PrivateRoute>
                <AllOrders />
              </PrivateRoute>
            }
          />
          <Route
            path="documents"
            element={
              <PrivateRoute>
                {orders.kitsAccess === true ? <Documents /> : <Navigate to="/reports" replace />}
              </PrivateRoute>
            }
          />
          {/* <Route
            path="reports"
            element={
              <PrivateRoute>
                <Reports />
              </PrivateRoute>
            }
          /> */}
          <Route
            path="reports"
            element={
              <PrivateRoute>
                {orders.reportsAccess === true ? <Reports2 /> : <Navigate to="/" replace />}
              </PrivateRoute>
            }
          />
          <Route
            path="*"
            element={
              <PrivateRoute>
                <Error />
              </PrivateRoute>
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
